import { Link } from 'react-router'
import type { JSX, ReactNode } from 'react'
import { Lockup } from '@/shell/Lockup'
import { ThemeToggle } from '@/components/ThemeToggle'

/**
 * The frame for every page reachable without a session.
 *
 * One column, centred, no shell — the reader may be on a phone, in a different
 * browser, or in a mail client's preview pane, and none of those has an
 * organisation selected for a sidebar to describe.
 *
 * The theme toggle is here as well as in the shell because "light and dark both
 * work, everywhere" (CLAUDE.md) includes the screens someone lands on from an
 * email, which for many people is the first AugRank screen they ever see.
 */
export function PublicPage({
  title,
  children,
  footer,
}: {
  title: string
  children: ReactNode
  footer?: ReactNode
}): JSX.Element {
  return (
    <div className="app-public">
      <div className="ar-row" style={{ width: 'min(28rem, 100%)' }}>
        <Link className="app-public__lockup" to="/">
          <Lockup />
        </Link>
        <span className="app-spacer" />
        <ThemeToggle />
      </div>

      <section className="ar-card app-public__card">
        <div className="ar-card__header">
          <h3>{title}</h3>
        </div>
        {children}
      </section>

      {footer ? <div className="app-public__foot">{footer}</div> : null}
    </div>
  )
}
